"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faSearch_1 = require("@fortawesome/pro-solid-svg-icons/faSearch");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var styles_1 = require("@mui/material/styles");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var StyledButton = (0, styles_1.styled)(TextButton_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        padding: theme.spacing(0, 0.75),
        color: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main,
        lineHeight: 1.2,
        letterSpacing: '-0.023em',
        marginLeft: theme.spacing(0.5),
        transition: 'background 20ms ease-in 0s',
        svg: {
            marginRight: theme.spacing(0.75),
            width: theme.typography.fontSize,
            height: theme.typography.fontSize,
        },
    });
});
var SearchButton = function (rest) { return ((0, jsx_runtime_1.jsxs)(StyledButton, __assign({ color: "neutral", size: "small" }, rest, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faSearch_1.faSearch }), " Search"] }))); };
exports.default = SearchButton;
